/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Slider from 'src/components/shared/Slider'
import { useLeadId } from 'src/common/lead-id'
import classNames from 'classnames'
import { useAnalytics } from '../../../common/analytics'
import styles from './index.module.scss'
import Image from 'next/image'
import Typography from '../Typography'

export default function DebtPopup({ onClose }) {
  const [debt, setDebt] = useState(25000)
  const router = useRouter()
  const { track } = useAnalytics()
  const sliderTitle = 'How much do you owe?'
  const leadId = useLeadId()

  const handleCheckEligibility = () => {
    router.push(
      `https://apply.freedomdebtrelief.com/home/?from=fdr&estimated_debt=${debt}&leadId=${leadId}`
    )
  }

  useEffect(() => {
    track(
      {
        additional_info: { section: 'exit-popup-view' },
        track_event: 'section_view',
        event_type: 'track',
        pageTitle: 'Repeat Anonymous - Popup Loaded',
        event_action: 'popup_view',
      },
      {},
      'popup_view'
    )
  }, [track])

  const handleOnClose = () => {
    track(
      {
        additional_info: { section: 'exit-popup-close' },
        track_event: 'section_view',
        event_type: 'track',
        pageTitle: 'Repeat Anonymous - Popup close',
        event_action: 'popup_close',
      },
      {},
      'popup_close'
    )
    onClose()
  }

  const handleSliderChange = useCallback((event) => {
    const { value } = event.target
    setDebt(value)
  }, [])

  const handleCheckEligibilityClick = useCallback(
    (e) => {
      e.preventDefault()

      const data = {
        click_type: 'Button Click',
        track_event: 'button_click',
        click_id: 'Check eligibility',
        click_text: `FDR-Web | Check eligibility`,
        nav_link_section: 'Popup',
        page_section: 'Free up more cash each month',
        form_ss_amount: debt,
        track_event: 'button_click',
        full_page_url: window?.location?.href,
        page_title: 'Homepage',
        pageTitle: 'Repeat Anonymous - Check eligibility clicked',
        event_action: 'popup_view',
      }

      track(data, {}, 'button_click')

      handleCheckEligibility()
    },
    [track, debt]
  )

  const handleSliderRelease = useCallback(
    (e) => {
      const data = {
        nav_link_section: 'Page',
        page_section: sliderTitle,
        click_type: 'Button Click',
        click_id: 'slider release',
        click_text: `$${e.target.value}`,
        form_ss_amount: +e.target.value,
        track_event: 'button_click',
      }
      if (typeof track === 'function') {
        track(data, {}, 'button_click')
      }
    },
    [track, sliderTitle]
  )

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContainer}>
        <div className={styles.closeBtn}>
          <Image
            priority
            src="/next-assets/icons/close.svg"
            alt="close tooltip"
            width={16}
            height={16}
            onClick={handleOnClose}
          />
        </div>
        <div className={styles.belowButton}>
          <div className={styles.avatarSection}>
            <img
              src="/next-assets/heart-comment-bubble.png"
              alt="Heart comment"
              className={styles.heartIcon}
            />
            <div className={styles.avatarCircle}>
              <img
                src="/next-assets/debt-pop-up.png"
                alt="Ozzy"
                className={styles.avatarImg}
              />
            </div>
            <Typography
              className={styles.avatarBadge}
              color="white"
              variant="bodyXSmall"
            >
              Ozzy S. resolved $22,593 🎉
            </Typography>
          </div>
          <div className={styles.headlineContainer}>
            <Typography variant="headingMedium" className="text-[32px]">
              Free up more cash each month
            </Typography>
            <Typography
              variant="bodyMedium"
              color="secondary"
              className={`${styles.subtext} text-[18px]`}
            >
              Let one of our experts review your debt to custom design a plan to
              tackle it.
            </Typography>
          </div>

          <div className="mb-5 flex w-full flex-col items-center rounded-[8px] bg-gray-25 px-6 py-4">
            <Typography variant="bodyMedium">{sliderTitle}</Typography>
            <Slider
              valueClassName="text-content-information text-[20px] w-full text-center mb-[8px]] mt-[8px]"
              containerClassName={classNames('w-full pb-5', styles.slider)}
              sliderClassName="mb-3 w-full appearance-none rounded-lg bg-gray-55 bg-slider-track-2 bg-no-repeat outline-none h-[4px]"
              showMinMaxLabels
              minMaxLabelsClassName={styles.minMaxLabels}
              onChange={handleSliderChange}
              start={debt}
              name="popupSlider"
              step={1000}
              min={1000}
              max={100000}
              unit="$"
              onSliderRelease={handleSliderRelease}
            />
          </div>

          <div className={styles.ctaBtnContainer}>
            <button
              className={styles.ctaBtn}
              onClick={handleCheckEligibilityClick}
            >
              Check eligibility
            </button>
          </div>

          <p className={styles.creditNote}>
            Your credit score will not be impacted.
          </p>

          <div className={styles.badges}>
            <span className={styles.greenBadge}>Free & secure</span>
            <span className={styles.greenBadge}>No obligation</span>
          </div>
        </div>
      </div>
    </div>
  )
}
